import { ACTIVITIES_TRAINING_TYPE } from '../../../shared/collection/collectionConstants';

export default function canBillToRamq(type) {
  return type !== ACTIVITIES_TRAINING_TYPE;
}
